import { gql } from '__generated__';

export default gql(`
  query GetContactFilters($project_id: ID!, $events: [ID!]!, $will_receive_messages: [ID!], $include_will_receive_messages: Boolean!, $include_received_messages: Boolean!) {
    project(id: $project_id) {
      id
      events(ids: $events) {
        data {
          id
          title
          allow_teams
        }
      }
      mail_permissions {
        id
        title
        interest_list_event {
          id
        }
        events {
          id
        }
        integration {
          id
        }
      }
      receivedMessages: messages(events: $events) @include (if: $include_received_messages) {
        data {
          id
          title
        }
      }
      willReceiveMessages: messages(ids: $will_receive_messages) @include (if: $include_will_receive_messages) {
        data {
          id
          title
        }
      }
    }
  }
`);
